// lib/constants.js
export const FORM_FIELDS_CONFIG = {
  firstName: {
    type: "text",
    label: "First name",
    placeholder: "Please enter your first name",
    required: true
  },
  lastName: {
    type: "text", 
    label: "Last name",
    placeholder: "Please enter your last name",
    required: true
  },
  email: {
    type: "email",
    label: "Email",
    placeholder: "you@example.com",
    required: true
  },
  message: {
    type: "textarea",
    label: "How did the Courtesy Patrol Help You?",
    placeholder: "Please tell us how the Courtesy Patrol helped you",
    rows: 4,
    required: true
  },
  safetyRating: {
    type: "select",
    label: "Did the patrol driver show concern for your safety, and act accordingly?",
    required: true
  },
  professionalismRating: {
    type: "select",
    label: "Was the patrol driver professional and courteous?",
    required: true
  },
  overallRating: {
    type: "select",
    label: "How would you rate the service?",
    required: true
  },
  surveyCode: {
    type: "text",
    label: "Did your driver provide you with a survey code? (optional)",
    placeholder: "ABCD5678",
    required: false
  }
};

export const INITIAL_FORM_DATA = Object.keys(FORM_FIELDS_CONFIG).reduce((acc, key) => {
  acc[key] = "";
  return acc;
}, {});

export const SELECT_OPTIONS = {
  rating: [
    { value: "", label: "Choose..." },
    { value: "excellent", label: "Excellent" },
    { value: "good", label: "Good" },
    { value: "fair", label: "Fair" },
    { value: "poor", label: "Poor" }
  ]
};

export const FIELD_OPTIONS_MAP = {
  safetyRating: SELECT_OPTIONS.rating,
  professionalismRating: SELECT_OPTIONS.rating,
  overallRating: SELECT_OPTIONS.rating
};

export const FORM_FIELDS_ORDER = [
  "firstName", 
  "lastName", 
  "email", 
  "message", 
  "safetyRating", 
  "professionalismRating", 
  "overallRating",
  "surveyCode"
];

export const QUESTION_MAP = {
  firstName: "First Name?",
  lastName: "Last Name?",
  email: "Email?",
  message: "How did the Courtesy Patrol Help You?",
  safetyRating: "Did the patrol driver show concern for your safety, and act accordingly?",
  professionalismRating: "Was the patrol driver professional and courteous?",
  overallRating: "How would you rate the service?",
  surveyCode: "Did your driver provide a survey code? (optional)",
};